const url="https://news.hogdata.cn"
export default{
	url
}
